import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_CONSULTING_BASE_URL;

export const loginUser = async (email, password) => {
  const response = await axios.post(`${API_BASE_URL}/auth/login`, { email, password });
  return response.data;
};

export const validateToken = async () => {
  try {
    const token = localStorage.getItem('access_token');
    if (!token) return { valid: false };
    
    const response = await axios.post(`${API_BASE_URL}/auth/validate`, {}, {
      headers: { Authorization: `Bearer ${token}` }
    });
    return { valid: true, user: response.data.user };
  } catch {
    return { valid: false };
  }
};

export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem('refresh_token');
  const response = await axios.post(`${API_BASE_URL}/auth/refresh`, {
    refresh_token: refreshToken
  });
  localStorage.setItem('access_token', response.data.access_token);
  return response.data;
};

// Interceptor para renovação automática
axios.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    const refreshToken = localStorage.getItem('refresh_token');
    
    // Redireciona para login em caso de 401 ou 403
    if (error.response?.status === 401 || error.response?.status === 403) {
      // Se não já tentou fazer refresh
      if (!originalRequest._retry) {
        originalRequest._retry = true;
        
        if (refreshToken) {
          try {
            await refreshAccessToken();
            // Atualiza o header da requisição original com o novo token
            originalRequest.headers.Authorization = `Bearer ${localStorage.getItem('access_token')}`;
            return axios(originalRequest);
          } catch (refreshError) {
            // Se o refresh falhar, limpa tudo e redireciona
            localStorage.clear();
            window.location.href = '/login';
            return Promise.reject(refreshError);
          }
        } else {
          // Não há refresh token, redireciona para login
          localStorage.clear();
          window.location.href = '/login';
          return Promise.reject(error);
        }
      } else {
        // Já tentou refresh e falhou, redireciona para login
        localStorage.clear();
        window.location.href = '/login';
        return Promise.reject(error);
      }
    }
    
    return Promise.reject(error);
  }
);

export const resetPassword = async (newPassword) => {
  try {
    const token = localStorage.getItem("access_token");
    const email = localStorage.getItem("userEmail");

    if (!token) {
      throw new Error("Token de autenticação não encontrado");
    }

    if (!email) {
      throw new Error("Email do usuário não encontrado");
    }

    await axios.patch(
      `${API_BASE_URL}/user/password`,
      {
        email: email,
        password: newPassword,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
  } catch (error) {
    if (error.response) {
      const message = error.response.data?.message || "Erro ao redefinir senha";
      throw new Error(message);
    } else if (error.request) {
      throw new Error("Erro de conexão. Verifique sua internet.");
    } else {
      throw new Error("Erro interno. Tente novamente.");
    }
  }
};
